module.exports = __webpack_public_path__ + "static/media/sort-up.97683f46.png";